import { Stack } from "@mui/material";
import { useSpacing } from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { ReadOnlyFieldContainer } from "../inputs/ReadOnlyFieldContainer";

export const ImmediateScheduleEmailForm: React.FC = () => {
  const { t } = useTranslation();
  const spacing = useSpacing();

  return (
    <Stack gap={spacing.spaceMD}>
      <ReadOnlyFieldContainer label={t("emailCycles.schedule")} required>
        {t("emailCycles.immediately")}
      </ReadOnlyFieldContainer>
    </Stack>
  );
};
